"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = exports.Slider = exports.SwitchWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.SwitchWrapper = styled_components_1.default.label `
  position: relative;
  display: inline-block;
  width: 24px;
  height: 16px;

  ${({ $isLarge }) => $isLarge &&
    (0, styled_components_1.css) `
      height: 20px;
      width: 32px;
    `}
`;
exports.Slider = styled_components_1.default.span `
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors_1.GREY2};
    border-radius: 21px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    ${({ $active }) => $active && `background-color: ${colors_1.DARK_GREEN};`}
    :before {
        position: absolute;
        content: '';
        height: 12px;
        width: 12px;
        left: 2px;
        bottom: 2px;
        background-color: ${colors_1.WHITE};
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
        ${({ $active }) => $active &&
    (0, styled_components_1.css) `
            -webkit-transform: translateX(8px);
            -ms-transform: translateX(8px);
            transform: translateX(8px);
            background-color: ${colors_1.WHITE};
          `}
        ${({ $active, $isLarge }) => $active &&
    $isLarge &&
    (0, styled_components_1.css) `
            -webkit-transform: translateX(14px);
            -ms-transform: translateX(14px);
            transform: translateX(14px);
            background-color: ${colors_1.WHITE};
          `}

        ${({ $isLarge }) => $isLarge &&
    (0, styled_components_1.css) `
            height: 14px;
            width: 14px;
            left: 2px;
            bottom: 3px;
          `}
    }
`;
exports.Checkbox = styled_components_1.default.input `
  opacity: 0;
  width: 0;
  height: 0;
  :focus {
    box-shadow: 0 0 1px ${colors_1.DARK_GREEN};
  }
`;
//# sourceMappingURL=Switch.styles.js.map